import React, { useEffect } from 'react';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
  selectAuthStatus,
  selectHasAccessToken,
  selectIsInitialized,
  selectIsOauthLoginCallback,
  loginWithAuthorizationCodeAction,
  getTokenInfoAction,
  logoutAction,
  selectIsSetPasswordCallback,
  authIsLoaded,
} from './authSlice';

type Props = {
  children: React.ReactNode;
};

export function AuthProvider(props: Props) {
  const dispatch = useAppDispatch();
  const auth_status = useAppSelector(selectAuthStatus);
  const has_access_token = useAppSelector(selectHasAccessToken);
  const is_initialized = useAppSelector(selectIsInitialized);
  const is_oauth_login_cb = useAppSelector(selectIsOauthLoginCallback);
  const is_signup_cb = useAppSelector(selectIsSetPasswordCallback);
  useEffect(() => {
    if (auth_status === 'loaded') {
      if (has_access_token) {
        dispatch(getTokenInfoAction());
      } else if (is_oauth_login_cb) {
        dispatch(loginWithAuthorizationCodeAction());
      } else if (is_signup_cb) {
        dispatch(authIsLoaded());
      } else{
        dispatch(logoutAction());
      }
    }
  }, [auth_status, has_access_token, is_oauth_login_cb, is_signup_cb, dispatch]);
  // login with authorization_code
  if (!is_initialized) {
    return (
      <div>Loading</div>
    );
  }
  return (
    <>
      {props.children}
    </>
  );
}
